import { brands } from '@atc/brand';

import fetchInvDetailsPage from '@/fetchers/fetchInvDetailsPage.js';

export default function addInvDetailsPageData() {
    return async (ctx) => {
        const { req, query = {} } = ctx;

        const headers = req ? req.headers : {};

        if (ctx.data.brand === brands.KBB_BRAND) {
            headers['X-fwd-svc'] = 'atc';
        }

        const options = {
            headers,
            query: { ...query },
        };

        const [, { channel }] = ctx.useFeature('brand');

        if (channel) {
            options.query.channel = channel;
        }

        const serverData = await fetchInvDetailsPage(options);
        const compositeFetchData = await ctx.fetchCompositeJSON.fetchComposite();

        Object.assign(ctx.data, serverData, compositeFetchData);
    };
}
